<div class="grow-allies-phrase-container">

    <!-- <prestamo-bar
      [icono]="icons.money"
      [texto]="'Préstamo para negocios'">
    </prestamo-bar> -->

    <div class="grow-allies-phrase-text">
      <span>Aliados de tu crecimiento.</span>
      <span>Obtén capital con condiciones claras y sin complicaciones.</span>
    </div>

</div>
